export default "__VITE_ASSET__1a4fb824__"